import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"

export const getIsProgressNoteEditable = (
  progressNote: ProgressNoteData,
  userName: string,
  appointmentId: string | null,
  isInContextOfAppointment: boolean,
) => {
  return (
    isInContextOfAppointment &&
    progressNote.appointment.id === appointmentId &&
    progressNote.appointment.isCompleted === false &&
    progressNote.createdBy === userName
  )
}
